// StatCard — reusable summary card
// Props: title, value, icon, color, description
export default function StatCard({ title, value, icon, color, description }) {
  return (
    <div style={{
      background: "rgba(15,23,42,0.92)",
      backdropFilter: "blur(20px)",
      borderRadius: 16,
      border: `1px solid ${color}30`,
      boxShadow: `0 4px 20px rgba(0,0,0,0.3)`,
      padding: "24px",
      animation: "fadeIn 0.5s ease",
      transition: "transform 0.2s",
      cursor: "default"
    }}
      onMouseOver={e => e.currentTarget.style.transform = "translateY(-3px)"}
      onMouseOut={e => e.currentTarget.style.transform = "translateY(0)"}
    >
      {/* Icon and title */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <span style={{ fontSize: 12.5, color: "#cbd5e1", letterSpacing: 1.2, textTransform: "uppercase", fontWeight: 600 }}>
          {title}
        </span>
      </div>

      {/* Value */}
      <div style={{ fontSize: 42, fontWeight: 800, color, marginBottom: 8, lineHeight: 1 }}>
        {value ?? '—'}
      </div>

      {/* Description */}
      <div style={{ fontSize: 14.5, color: "#cbd5e1" }}>
        {description}
      </div>
    </div>
  );
}